import { render } from "./choose_bank_payment.vue?vue&type=template&id=7b9d0bf4"
import script from "./choose_bank_payment.vue?vue&type=script&lang=js"
export * from "./choose_bank_payment.vue?vue&type=script&lang=js"

import "./choose_bank_payment.vue?vue&type=style&index=0&id=7b9d0bf4&lang=css"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__